import { Layout } from 'components/layout';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IApp } from 'stores/AllStores';

// Component
@inject('store')
@observer
export class SalesMain extends React.Component<IApp, {}> {
  constructor(props: IApp) {
    super(props);
  }

  public render() {
    return <Layout>{this.props.children}</Layout>;
  }
}

export default SalesMain;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/SalesMain.tsx